import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Document } from 'jsonapi-typescript';
import { map, Observable } from 'rxjs';
import { uuidv7 } from 'uuidv7';
import { UserGrantPayload } from '../interfaces/user-grant-payload.interface';
import { serializeUserGrant } from '../serializers/user-grant.serializer';
import { ENVIRONMENT } from '../tokens/environment.token';

@Injectable({ providedIn: 'root' })
export class UserGrantsApiService {
	private httpClient = inject(HttpClient);
	private environment = inject(ENVIRONMENT);

	create(grant: UserGrantPayload): Observable<string> {
		const id = uuidv7();
		return this.httpClient
			.post<Document>(
				this.environment.serverNew + '/user/v1/user-grants',
				serializeUserGrant(grant, id)
			)
			.pipe(map(() => id));
	}

	delete(grantId: string): Observable<void> {
		return this.httpClient.delete<void>(
			this.environment.serverNew + `/user/v1/user-grants/${grantId}`
		);
	}
}
